import UnreadCommentIcon from './UnreadCommentIcon';
import Icon from './Icon';
export default Object.assign(Icon, { UnreadCommentIcon });
